<template>
  <div>
    <button class="fab-btn" @click="showModal">
      <svg style="width:24px;height:24px" viewBox="0 0 24 24">
        <path fill="#FFF" d="M16.84,2.73C16.45,2.73 16.07,2.88 15.77,3.17L13.65,5.29L18.95,10.6L21.07,8.5C21.67,7.89 21.67,6.94 21.07,6.36L17.9,3.17C17.6,2.88 17.22,2.73 16.84,2.73M12.94,6L4.84,14.11L7.4,14.39L7.58,16.68L9.86,16.85L10.15,19.41L18.25,11.3M4.25,15.04L2.5,21.73L9.2,19.94L8.96,17.78L6.65,17.61L6.47,15.29" />
      </svg>
    </button>
  </div>
</template>

<script>
  export default {
    methods: {
      showModal: function () {
        this.$router.push({ path: '/contact' })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .fab-btn {
    width: 55px;
    height: 55px;
    background-color: #009688;
    border-radius: 50%;
    border: none;
    position: fixed;
    bottom: 50px;
    right: 50px;
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    z-index: 3;
    -webkit-tap-highlight-color: transparent;
    outline: none;
    cursor: pointer;
  }

  /*styles for smaller screens*/

  @media (max-width: 767px) {
    .fab-btn {
      bottom: 100px;
      right: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// Fab.vue?e6e9ce56